const $get_image = function (id = '') {
  if (!id.length) return ''

  let url = import.meta.env.VITE_VUE_APP_FRONT_URL ?? ''
  url += `/api/file/serve/${id}`
  return url
}

const plugin = {
  install: (app, options) => {
    app.config.globalProperties.$get_image = $get_image
    app.provide('$get_image', { $get_image })
  }
}

export default plugin
